import { Dispatch, Fragment, SetStateAction } from 'react';
import {
  Dialog,
  DialogPanel,
  Transition,
  TransitionChild
} from '@headlessui/react';
import SideNav from '@components/layout/sidebar/side-nav.tsx';
import cn from 'classnames';
import { X } from 'lucide-react';

interface Props {
  sidebarOpen: boolean;
  setSidebarOpen: Dispatch<SetStateAction<boolean>>;
}

export default function ResponsiveSideNav(props: Props) {
  return (
    <Transition
      show={props.sidebarOpen}
      as={Fragment}
      enter="transition-opacity ease-linear duration-300"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition-opacity ease-linear duration-300"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <Dialog
        as="div"
        className={cn('lg:hidden', 'relative')}
        onClose={() => props.setSidebarOpen(false)}
      >
        <div className="fixed inset-0 bg-gray-900/80">
          <button
            type="button"
            className="absolute top-5 right-5 cursor-pointer"
            onClick={() => props.setSidebarOpen(false)}
          >
            <span className="sr-only">Close sidebar</span>
            <X className="h-5 w-5 text-white" aria-hidden="true" />
          </button>
        </div>
        <div className="fixed inset-0 flex">
          <TransitionChild
            as={Fragment}
            enter="transition ease-in-out duration-300 transform"
            enterFrom="-translate-x-full"
            enterTo="translate-x-0"
            leave="transition ease-in-out duration-300 transform"
            leaveFrom="translate-x-0"
            leaveTo="-translate-x-full"
          >
            <DialogPanel className="relative flex w-full max-w-xs flex-1">
              <SideNav />
            </DialogPanel>
          </TransitionChild>
        </div>
      </Dialog>
    </Transition>
  );
}
